import SumedhKid1 from "../Assets/Sumedh-Kid-1.jpeg";
import SumedhKid2 from "../Assets/Sumedh-Kid-2.jpeg";
import SumedhKid1_16May from "../Assets/Sumedh-Kid-1-16May26.jpeg";
import SumedhKid2_16May from "../Assets/Sumedh-Kid-2-16May26.jpeg";

const SanJosePhotos = [
  {
    img: SumedhKid1_16May,
    alt: "Sumedh playing with a young player - May 16, 2026 San Jose Table Tennis",
  },
  {
    img: SumedhKid2_16May,
    alt: "Sumedh coaching a young player - May 16, 2026 San Jose Table Tennis",
  },
  {
    img: SumedhKid2,
    alt: "Sumedh coaching a young player - San Jose Table Tennis",
  },
  {
    img: SumedhKid1,
    alt: "Sumedh playing with a young player - San Jose Table Tennis",
  },
];

export default SanJosePhotos;